module.exports = __webpack_public_path__ + "static/media/deven.47f55ee7.jpg";